import { type PublicClip } from '@air/api';
import { type Board, type Clip, type PublicBoard } from '@air/api/types';
import { type Upload } from '@air/redux-uploader';

import { type GalleryItemType } from '~/components/Gallery/types';
import { type TableRowType } from '~/components/TableView/basicTypes';

export type BasicTableRowProps<T> = {
  data: T;
};

export type AirTableMetadata = {
  isSelectable: boolean;
  type: GalleryItemType.board | GalleryItemType.file | GalleryItemType.upload | GalleryItemType.asset;
  item: PublicBoard | Board | Clip | PublicClip | Upload;
};

export type AirTableRow = {
  getMetadata?: () => AirTableMetadata;
} & TableRowType;

const TITLE_COLUMN_WIDTH = 400;
const BUTTONS_COLUMN_WIDTH = 68;
const DEFAULT_COLUMN_WIDTH = 160;
const MODIFIED_DATE_COLUMN_WIDTH = 170;
const UPLOADED_DATE_COLUMN_WIDTH = 190;
const UPLOADER_COLUMN_WIDTH = 220;
const EXTENSION_COLUMN_WIDTH = 115;
const RESOLUTION_COLUMN_WIDTH = 125;
const COMPACT_COLUMN_WIDTH = 90;
const COUNT_COLUMN_WIDTH = 110;
const COMMENTS_COLUMN_WIDTH = 150;
const BOARDS_COLUMN_WIDTH = 120;
const CUSTOM_FIELD_COLUMN_WIDTH = 240;

export const getTableColumnWidth = (key: string) => {
  switch (key) {
    case 'title':
      return TITLE_COLUMN_WIDTH;
    case 'buttons':
      return BUTTONS_COLUMN_WIDTH;
    case 'dateCreated':
    case 'dateTaken':
      return DEFAULT_COLUMN_WIDTH;
    case 'dateModified':
      return MODIFIED_DATE_COLUMN_WIDTH;
    case 'dateUploaded':
      return UPLOADED_DATE_COLUMN_WIDTH;
    case 'uploadedBy':
      return UPLOADER_COLUMN_WIDTH;
    case 'ext':
      return EXTENSION_COLUMN_WIDTH;
    case 'resolution':
      return RESOLUTION_COLUMN_WIDTH;
    case 'size':
      return COMPACT_COLUMN_WIDTH;
    case 'tagCount':
    case 'views':
    case 'downloads':
      return COUNT_COLUMN_WIDTH;
    case 'openCommentCount':
      return COMMENTS_COLUMN_WIDTH;
    case 'boardCount':
      return BOARDS_COLUMN_WIDTH;
    case 'customField':
      return CUSTOM_FIELD_COLUMN_WIDTH;
    case 'type':
      return COMPACT_COLUMN_WIDTH;
    default:
      return DEFAULT_COLUMN_WIDTH;
  }
};

export type ActiveTableColumn = {
  fieldName: string;
  isCustomField: boolean;
  customFieldId?: string;
};

export const rightAlignedTableCells = new Set(['tagCount', 'openCommentCount', 'boardCount', 'views', 'downloads']);

export type OnRenameFunction = () => void;
